<h2 mat-dialog-title>{{data.title}}</h2>
<mat-dialog-content>
  <ngx-json-viewer [json]="data.content" [expanded]="false"></ngx-json-viewer>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button mat-dialog-close>{{'close'|traduccion}}</button>
</mat-dialog-actions>
